import { Commons } from '../commons'
import axios from 'axios'

async function request(
  method,
  url,
  headers = null,
  auth = null,
  data = null,
  responseType = null,
) {
  const requestConfig = {
    url,
    method,
  }
  Commons.isEmpty(headers) ? null : (requestConfig.headers = headers)
  Commons.isEmpty(auth) ? null : (requestConfig.auth = auth)
  data ? (requestConfig.data = data) : null
  Commons.isEmpty(responseType)
    ? null
    : (requestConfig.responseType = responseType)

  const response = await axios.request(requestConfig).catch(error => {
    console.log(`Failed caused by access to : ${url} with error :  ${error}`)
    console.log(error.message)

    return error.response || error
  })

  return {
    status: { code: response.status },
    response: response.data || response,
  }
}

async function savePicture(picture) {
  const response = await uploadPicture(picture)
  const parsedResponse = parseResponse(response)
  return parsedResponse
}

async function uploadPicture(picture) {
  let url = `https://apis.ecoxurf.com/fileupload/file/upload`

  const requestData = new FormData()
  requestData.append('field', picture)

  const header = {
    'Content-Type': 'multipart/form-data',
  }
  const response = request('post', url, header, null, requestData)
  return response
}

function parseResponse(response) {
  console.log('res', response)
  if (
    response.status.code === 200 ||
    response.status.code === 201 ||
    response.status.code === 202
  ) {
    const data = {
      ...response.response,
      fileUrl:
        'https://apis.ecoxurf.com/fileupload/file/download/' +
        response.response.id +
        response.response.ext,
    }
    return {
      success: true,
      message: '',
      data,
    }
  }
  if (response.status.code === 401) {
    return {
      success: false,
      unauthorized: true,
      message: '',
    }
  }
  if (response.status.code === 400) {
    const data = response.response.data
    return {
      success: false,
      unauthorized: true,
      badPictureError: !!data.badPicture,
      message: '',
    }
  }
  if (response.status.code === 403) {
    return {
      success: false,
      forbidden: true,
      message: 'Forbidden',
    }
  }
  if (response.status.code === 500) {
    return {
      success: false,
      message: 'Sorry, an error occured. Chec Please try again later',
    }
  }
  return {
    success: false,
    message: 'Sorry an error occured. Check your netword and retry',
  }
}

export { savePicture }
